import { serviceLoading } from 'common/loaderReducer';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store/types';
import { WidgetContainer,WidgetTitle,InlineLeft,Info,ToolTipContainer,IconContainer,ToolTipLabel } from '../styles';
import ChartDoughnut from 'components/ChartDoughnut';
import info from '../../../../../common/images/icon-info.svg';
import { getCompletenessAPI } from './state/actions';
import { GET_COMPLETENESS_API_REQUEST } from 'features/Dealers/Performance/Widgets/ProfileCompleteness/state/actionTypes';
import Loader from 'components/Loader';
import sectionspaces from './sectionspaces.png'

const WidgetProfileCompleteness = () => {
    const dispatch = useDispatch();

    const rootProps = useSelector((rootState: RootState) => {
        const isRequesting = serviceLoading(rootState, [GET_COMPLETENESS_API_REQUEST]);
        return {
            websiteProvider: rootState.dealers.dealer.websiteProvider,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            WidgetColors: rootState.dealers.performanceCompleteness.completessInfo?.colors,
            WidgetText: rootState.dealers.performanceCompleteness.completessInfo?.text,
            WidgetLegendItems: rootState.dealers.performanceCompleteness.completessInfo?.legendItems,
            WidgetValues: rootState.dealers.performanceCompleteness.completessInfo?.values,
            isRequesting
        }
    }, shallowEqual);

    React.useEffect(() => {
        dispatch(getCompletenessAPI(rootProps.dealerId));
    }, []);

    return (
        <WidgetContainer>
            <InlineLeft>
                <WidgetTitle>
                    {rootProps.websiteProvider?.displayName ?? 'DealerOn'} Profile Completeness
                </WidgetTitle>
                <IconContainer>
                <Info>
                    <img src={info}></img>
                </Info>
                <ToolTipContainer>
                    <ToolTipLabel>
                        This score is calculated by adding all the sections that are completed in Listings Manager based on our recommended best practices.
                    </ToolTipLabel>
                </ToolTipContainer>
                </IconContainer>
            </InlineLeft>
            {
                rootProps.isRequesting &&
                    <Loader/>
            }
            {
                !rootProps.isRequesting &&
                <ChartDoughnut
                    OuterRingData={rootProps.WidgetValues}
                    OuterRingColors={rootProps.WidgetColors}
                    OuterRingDataSpacer={0}
                    innerTextLine1={rootProps.WidgetText}
                    ShowLegend={true}
                    LegendItems={rootProps.WidgetLegendItems}
                    OuterRingAnimation={true}
                    OuterRingCutOut={92}
                    LegendPosition={window.innerWidth>2200?'RIGHT':'BOTTOM'}
                    ImageSpacer={sectionspaces}
                    />
            }
        </WidgetContainer>
    )
}

export default WidgetProfileCompleteness
